import React from "react";

// Data for the SDLC stages
const sdlcTopics = [
  {
    name: "Requirement Analysis",
    color: "bg-purple-600",
    icon: "📋",
    top: "top-0",
    left: "left-1/2",
    transform: "-translate-x-1/2 -translate-y-1/4",
  },
  {
    name: "System Design",
    color: "bg-orange-600",
    icon: "📐",
    top: "top-1/4",
    right: "right-0",
    transform: "translate-x-1/4 -translate-y-1/2",
  },
  {
    name: "Implementation",
    color: "bg-yellow-600",
    icon: "💻",
    top: "top-3/4",
    right: "right-0",
    transform: "translate-x-1/4 -translate-y-1/2",
  },
  {
    name: "Testing & QA",
    color: "bg-green-600",
    icon: "🧪",
    bottom: "bottom-0",
    left: "left-2/3",
    transform: "-translate-x-1/2 translate-y-1/4",
  },
  {
    name: "Deployment",
    color: "bg-lime-600",
    icon: "🚀",
    bottom: "bottom-0",
    left: "left-1/3",
    transform: "-translate-x-1/2 translate-y-1/4",
  },
  {
    name: "Maintenance",
    color: "bg-blue-600",
    icon: "🛠️",
    top: "top-3/4",
    left: "left-0",
    transform: "-translate-x-1/4 -translate-y-1/2",
  },
  {
    name: "Security Auditing",
    color: "bg-purple-600",
    icon: "🛡️",
    top: "top-1/4",
    left: "left-0",
    transform: "-translate-x-1/4 -translate-y-1/2",
  },
];

// Reusable Topic Circle Component
const TopicCircle = ({ topic }) => (
  <div
    className={`absolute w-36 h-36 rounded-full flex flex-col items-center justify-center p-2 
      ${topic.color} text-white bg-opacity-90 shadow-xl z-20 
      ${topic.top} ${topic.bottom} ${topic.left} ${topic.right} ${topic.transform}`}
  >
    <span className="text-2xl">{topic.icon}</span>
    <p className="text-sm font-semibold text-center mt-1">{topic.name}</p>
  </div>
);

// Main Component
const SDLCInfographic = () => {
  return (
    <div className="relative flex justify-center items-center w-full min-h-screen bg-white overflow-hidden py-20">
      {/* 🔴 Left Red Hexagonal Background Shape */}
      <div
        className="absolute top-0 left-0 w-64 h-full bg-purple-800"
        style={{ clipPath: "polygon(0 0, 75% 0, 100% 50%, 75% 100%, 0 100%)" }}
      />

      {/* 🔴 Right Red Hexagonal Background Shape */}
      <div
        className="absolute bottom-0 right-0 w-64 h-full bg-purple-800"
        style={{
          clipPath: "polygon(25% 0, 100% 0, 100% 100%, 25% 100%, 0 50%)",
        }}
      />

      {/* Infographic Container */}
      <div className="relative w-[36rem] h-[36rem] flex justify-center items-center z-30">
        {/* Render all SDLC Circles */}
        {sdlcTopics.map((topic) => (
          <TopicCircle key={topic.name} topic={topic} />
        ))}

        {/* Center Software Development Circle */}
        <div className="relative w-56 h-56 rounded-full bg-black text-white flex flex-col items-center justify-center z-40 shadow-2xl ring-4 ring-gray-600 ring-opacity-50">
          <div className="text-lg font-bold tracking-widest text-gray-300">
            SOFTWARE
          </div>
          <div className="text-2xl font-extrabold tracking-widest mt-1 text-center px-4">
            DEVELOPMENT
          </div>
        </div>
      </div>
    </div>
  );
};

export default SDLCInfographic;
